import { render, staticRenderFns } from "./UserProjectCard.vue?vue&type=template&id=04ee4d47&"
import script from "./UserProjectCard.vue?vue&type=script&lang=js&"
export * from "./UserProjectCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports